import React, { Component } from 'react';
import { ListBoxItem } from '.';
import PropTypes from 'prop-types';

export class ListBox extends Component {
  render() {
    const { children, data } = this.props;
    const listboxItems = data && data.map( ( item, key ) => <ListBoxItem key={ key } item={ item } { ...this.props } /> );

    return <div className="list-box">
      { children }
      { listboxItems }
    </div>;
  }
}

ListBox.propTypes = {
  children: PropTypes.arrayOf( PropTypes.node ),
  data: PropTypes.arrayOf( PropTypes.object )
};